import { render } from "./ProgressaoPeriodo.vue?vue&type=template&id=0ed65a53"
import script from "./ProgressaoPeriodo.vue?vue&type=script&lang=js"
export * from "./ProgressaoPeriodo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__